"use client";

import {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "./tooltip";
import { Popover, PopoverTrigger, PopoverContent } from "./popover";
import { cn } from "@/lib/utils";

const TouchContext = createContext(undefined);
const useTouch = () => useContext(TouchContext);

const TouchProvider = (props) => {
  const [isTouch, setTouch] = useState();

  useEffect(() => {
    setTouch(window.matchMedia("(pointer: coarse)").matches);
  }, []);

  return <TouchContext.Provider value={isTouch} {...props} />;
};

const HybridTooltipProvider = (props) => {
  return <TooltipProvider delayDuration={0} {...props} />;
};

const HybridTooltip = (props) => {
  const isTouch = useTouch();

  return isTouch ? <Popover {...props} /> : <Tooltip {...props} />;
};

const HybridTooltipTrigger = (props) => {
  const isTouch = useTouch();

  return isTouch ? (
    <PopoverTrigger {...props} />
  ) : (
    <TooltipTrigger {...props} />
  );
};

const HybridTooltipContent = ({ className, sideOffset = 4, ...props }) => {
  const isTouch = useTouch();

  if (isTouch) {
    return (
      <PopoverContent
        className={cn(
          "bg-background-purplish border border-white/50 text-foreground-300 z-50 w-fit rounded-md px-3 py-1.5 font-medium text-balance",
          className
        )}
        sideOffset={sideOffset}
        {...props}
      />
    );
  }

  return (
    <TooltipContent className={className} sideOffset={sideOffset} {...props} />
  );
};

export {
  TouchProvider,
  HybridTooltipProvider,
  HybridTooltip,
  HybridTooltipTrigger,
  HybridTooltipContent,
};
